import {NgModule} from '@angular/core';
import {CommonModule, registerLocaleData} from '@angular/common';
import {WizardComponent} from './componentes/principal/wizard.component';
import {MatSidenavModule} from "@angular/material/sidenav";
import {RouterModule} from "@angular/router";
import {MatIconModule} from "@angular/material/icon";
import {MatProgressBarModule} from "@angular/material/progress-bar";
import {MatTabsModule} from "@angular/material/tabs";
import {MatButtonModule} from "@angular/material/button";
import {HeaderComponent} from './componentes/header/header.component';
import {ToolbarComponent} from './componentes/toolbar/toolbar.component';
import {SteppsComponent} from './componentes/stepps/stepps.component';
import {ButtonsComponent} from './componentes/buttons/buttons.component';
import {ContainerComponent} from './componentes/container/container.component';
import {SectionComponent} from './componentes/section/section.component';
import {DynamicContainerDirective} from './componentes/base/dynamic-container.directive';
import {EvkFormsModule} from "@evomatik/evk-forms";
import {PortalModule} from "@angular/cdk/portal";
import {MatMenuModule} from "@angular/material/menu";
import {MatTooltipModule} from "@angular/material/tooltip";
import {MatToolbarModule} from "@angular/material/toolbar";
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {DatosGeneralesComponent} from './componentes/section/sub-components/datos-generales/datos-generales.component';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {FlexLayoutModule, FlexModule} from '@angular/flex-layout';
import {EvkCommonModule} from "@evomatik/evk-common";
import {EvkMatTypographyModule} from "./directives/typography/mat-typography.module";
import {
    ExpedientesDetalleComponent
} from './componentes/section/sub-components/expedientes/expedientes-detalle/expedientes-detalle.component';
import {
    DetalleCardComponent
} from './componentes/section/sub-components/expedientes/expedientes-detalle/detalle-card/detalle-card.component';
import {MatCardModule} from '@angular/material/card';
import {TablaPageComponent} from './componentes/section/sub-components/tabla-page/tabla-page.component';
import {MatTableModule} from "@angular/material/table";
import {ExtractDataPipe} from './pipes/extract-data.pipe';
import {EvalFnPipe} from './pipes/eval-fn.pipe';
import {ContenedorBaseComponent} from './componentes/section/sub-components/contenedor-base/contenedor-base.component';
import {EvkContentModule} from "@evomatik/evk-content";
import {
    ContenedorFormatosComponent
} from './componentes/section/sub-components/contenedor-formatos/contenedor-formatos.component';
import {MatDialogModule} from "@angular/material/dialog";
import {MatProgressSpinnerModule} from "@angular/material/progress-spinner";
import {
    InformacionGeneralComponent
} from './componentes/section/sub-components/expedientes/expedientes-detalle/informacion-general/informacion-general.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatSelectModule} from '@angular/material/select';
import {
    ContenedorAdjuntarComponent
} from './componentes/section/sub-components/contenedor-adjuntar/contenedor-adjuntar.component';
import {
    DifusionDialogComponent
} from './componentes/section/sub-components/expedientes/expedientes-detalle/informacion-general/difusion-dialog/difusion-dialog.component';
import {DocumentosComponent} from './componentes/section/sub-components/custom/documentos/documentos.component';
import {
    DiligenciaDetalleComponent
} from './componentes/section/sub-components/diligencias/diligencia-detalle/diligencia-detalle.component';
import {
    InformacionDiligenciaComponent
} from './componentes/section/sub-components/diligencias/informacion-diligencia/informacion-diligencia.component';
import {FirmaModule} from "../firma/firma.module";
import { MotivoRechazoComponent } from './componentes/section/sub-components/diligencias/motivo-rechazo-component/motivo-rechazo.component';
import { DiligenciaAsignacionComponent } from './componentes/section/sub-components/diligencias/diligencia-asignacion/diligencia-asignacion.component';
import { DiligenciaAsignacionFormComponent } from './componentes/section/sub-components/diligencias/diligencia-asignacion/diligencia-asignacion-form/diligencia-asignacion-form.component';
import {
    TurnarDiligenciaFormComponent
} from "./componentes/section/sub-components/diligencias/diligencia-turnar/diligencia-turnar-form/diligencia-turnar-form.component";
import {
    DiligenciaTurnarComponent
} from "./componentes/section/sub-components/diligencias/diligencia-turnar/diligencia-turnar-dialog/diligencia-turnar.component";
import {
    SolicitarAutorizacionCreateComponent
} from "./componentes/section/sub-components/diligencias/solicitar-autorizacion/solicitar-autorizacion-create/solicitar-autorizacion-create.component";
import {
    SolicitarAutorizacionCreateFormComponent
} from "./componentes/section/sub-components/diligencias/solicitar-autorizacion/solicitar-autorizacion-create-form/solicitar-autorizacion-create-form.component";
import {
    MotivoCancelacionCreateComponent
} from "./componentes/section/sub-components/diligencias/diligencia-motivo-cancelacion/motivo-cancelacion/motivo-cancelacion-create.component";
import {
    MotivoFormComponent
} from "./componentes/section/sub-components/diligencias/diligencia-motivo-cancelacion/motivo-form/motivo-form.component";
import {
    EnAutorizacionDiligenciaCreateComponent
} from "./componentes/section/sub-components/diligencias/en-autorizacion-diligencia/en-autorizacion-diligencia-create/en-autorizacion-diligencia-create.component";
import {
    EnAutorizacionDiligenciaFormComponent
} from "./componentes/section/sub-components/diligencias/en-autorizacion-diligencia/en-autorizacion-diligencia-form/en-autorizacion-diligencia-form.component";
import {
    MotivoRechazoFormComponent
} from "./componentes/section/sub-components/diligencias/motivo-rechazo/motivo-rechazo-form/motivo-rechazo-form.component";
import {
    MotivoRechazoCreateComponent
} from "./componentes/section/sub-components/diligencias/motivo-rechazo/motivo-rechazo-create/motivo-rechazo-create.component";
import {
    MotivoEstadoComponent
} from "./componentes/section/sub-components/diligencias/motivo-estado/motivo-estado.component";
import { TerminosCondicionesComponent } from './componentes/section/sub-components/terminos-condiciones/terminos-condiciones.component';
import {
    ValidacionCodigoComponent
} from "./componentes/section/sub-components/validacion-codigo/validacion-codigo.component";
import {
    ConfirmacionRegistroComponent
} from "./componentes/section/sub-components/confirmacion-registro/confirmacion-registro.component";

import { DirectorioOficinasComponent } from './componentes/section/sub-components/directorio-oficinas/directorio-oficinas.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {EvkMapasComponent} from "./componentes/section/sub-components/evk-mapas/evk-mapas.component";
import {EvkMapaComponent} from "./componentes/section/sub-components/evk-mapas/mapas/evk-mapa/evk-mapa.component";
import {MapasContainerComponent} from "./componentes/section/sub-components/mapas-container/mapas-container.component";
import { GeneracionRequerimientoComponent } from './componentes/section/sub-components/generacion-requerimiento/generacion-requerimiento.component';
import {MaterialFileInputModule} from "ngx-material-file-input";
import {SeagedCsrLibraryModule} from "@evomatik/seaged-csr-library";
import {CargarRequerimientoComponent} from './componentes/section/sub-components/cargar-requerimiento/cargar-requerimiento.component';
import {SolicitudFirmaComponent} from './componentes/section/sub-components/solicitud-firma/solicitud-firma.component';
import { SimpleSectionComponent } from './componentes/simple-section/simple-section.component';
import { BiometricosBiosphereComponent } from './componentes/section/sub-components/biometricos-biosphere/biometricos-biosphere.component';
import { SolicitudPagoComponent } from './componentes/section/sub-components/solicitud-pago/solicitud-pago.component';
import { EvomatikGoogleMapsComponent } from './componentes/section/sub-components/evomatik-google-maps/evomatik-google-maps.component';
import { GoogleMapsModule } from '@angular/google-maps';
import es from '@angular/common/locales/es';

registerLocaleData(es);

@NgModule({
    declarations: [
        WizardComponent,
        HeaderComponent,
        ToolbarComponent,
        SteppsComponent,
        ButtonsComponent,
        ContainerComponent,
        SectionComponent,
        DynamicContainerDirective,
        DatosGeneralesComponent,
        ExpedientesDetalleComponent,
        DetalleCardComponent,
        TablaPageComponent,
        ExtractDataPipe,
        EvalFnPipe,
        ContenedorBaseComponent,
        ContenedorFormatosComponent,
        InformacionGeneralComponent,
        ContenedorAdjuntarComponent,
        DifusionDialogComponent,
        DocumentosComponent,
        DiligenciaDetalleComponent,
        InformacionDiligenciaComponent,
        MotivoRechazoComponent,
        DiligenciaAsignacionComponent,
        DiligenciaAsignacionFormComponent,
        TurnarDiligenciaFormComponent,
        DiligenciaTurnarComponent,
        SolicitarAutorizacionCreateComponent,
        SolicitarAutorizacionCreateFormComponent,
        MotivoCancelacionCreateComponent,
        MotivoFormComponent,
        EnAutorizacionDiligenciaCreateComponent,
        EnAutorizacionDiligenciaFormComponent,
        MotivoRechazoCreateComponent,
        MotivoRechazoFormComponent,
        MotivoEstadoComponent,
        TerminosCondicionesComponent,
        ValidacionCodigoComponent,
        ConfirmacionRegistroComponent,
        DirectorioOficinasComponent,
        EvkMapasComponent,
        EvkMapaComponent,
        MapasContainerComponent,
        GeneracionRequerimientoComponent,
        SolicitudPagoComponent,
        BiometricosBiosphereComponent,
        CargarRequerimientoComponent,
        SolicitudFirmaComponent,
        SimpleSectionComponent,
        EvomatikGoogleMapsComponent
    ],
    imports: [
        CommonModule,
        MatSidenavModule,
        RouterModule,
        MatIconModule,
        MatProgressBarModule,
        MatTabsModule,
        MatCardModule,
        MatButtonModule,
        EvkFormsModule,
        PortalModule,
        MatMenuModule,
        MatTooltipModule,
        MatToolbarModule,
        MatSnackBarModule,
        MatInputModule,
        MatFormFieldModule,
        ReactiveFormsModule,
        FormsModule,
        FlexModule,
        FlexLayoutModule,
        EvkCommonModule,
        EvkMatTypographyModule,
        MatTableModule,
        EvkContentModule,
        MatDialogModule,
        MatProgressSpinnerModule,
        MatChipsModule,
        MatAutocompleteModule,
        MatSelectModule,
        FirmaModule,
        MatExpansionModule,
        MaterialFileInputModule,
        SeagedCsrLibraryModule,
        GoogleMapsModule
    ],
    exports: [
        WizardComponent,
        CargarRequerimientoComponent,
        SimpleSectionComponent,
        EvkMapasComponent,
    ]
})
export class WizardModule {
}
